<template><div><h1 id="op-guthabenliste" tabindex="-1"><a class="header-anchor" href="#op-guthabenliste"><span>OP-Guthabenliste</span></a></h1>
<p>OP-Guthabenliste — Listet sämtliche Guthaben auf, welche im System vorhanden sind</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Auswertung listet sämtliche Guthaben auf, welche im System vorhanden sind. Sie dient der Bereinigung von kreditorischen Debitoren. Die Daten können nach einem Stichdatum eingegrenzt werden: Guthaben, welche nach diesem Datum entstanden sind, werden in der Auswertung nicht aufgelistet. Bei Guthaben wird immer das Datum der letzten Bewegung festgehalten. Eine Bewegung kann die Bildung oder den Verzehr eines freien Guthabens bedeuten. Auswahlkriterien ermöglichen eine weitere Einschränkung der Daten. Beim Output kann die Sortierung gewählt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Guthabenliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Stichdatum:</dt>
<dd>
<p>Adressen mit Guthaben, welche erst nach diesem Datum entstanden sind, werden nicht aufgelistet.</p>
</dd>
<dt>Auswahlkriterien:</dt>
<dd>
<ol>
<li>nur Guthaben von Adressen mit offenen Fakturen. Ein sinnvolles Kriterium, wenn Guthaben überprüft werden sollen, zu denen evtl. fehlgeleitete Zahlungen existieren, so dass Guthaben entstanden, vorhandene Offene Posten aber nicht ausgeglichen wurden. Der Saldo der Offenen Posten (offenen Fakturen) wird per [Laufdatum] ausgewiesen</li>
</ol>
</dd>
<dd>
<ol start="2">
<li>nur Guthaben von Adressen ohne offene Fakturen. Ein sinnvolles Kriterium, wenn Kundenguthaben avisiert werden sollen oder wenn Fehlbuchungen gesucht werden sollen</li>
</ol>
</dd>
<dd>
<ol start="3">
<li>alle vorhandenen Guthaben</li>
</ol>
</dd>
<dt>Sortierung nach:</dt>
<dd>
<p>A = Personen-ID, aufsteigendD = Datum letzte Guthabenänderung, absteigend</p>
</dd>
<dt>Ausgabe</dt>
<dd>
<p>Standard (Drucker: A4-Portrait)</p>
</dd>
<dt>- Bildschirm</dt>
<dd>
<ul>
<li>Bildschirm</li>
</ul>
</dd>
<dt>- Drucker:</dt>
<dd>
<p>A4 hoch</p>
</dd>
<dt>- Textdatei:</dt>
<dd>
<p>Text</p>
</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adrnr:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name:</td>
<td>Adressname / -vorname</td>
</tr>
<tr>
<td>Datum:</td>
<td>Datum letzte Guthabenänderung, -bewegung</td>
</tr>
<tr>
<td>Saldo Guth:</td>
<td>Saldo des Guthabens per [Stichdatum]</td>
</tr>
<tr>
<td>Saldo Guth:</td>
<td>Saldo des Guthabens per [Stichdatum]</td>
</tr>
</tbody>
</table>
<p>offene Fakturen: Saldo offener Fakturen zur Adresse per [Laufdatum]</p>
<p>Outputbeispiel (alle 3 Varianten gleich)</p>
<p>-------------------------------------------------------------------------
OP-Guthabenliste
Auswahlkriterien: alle vorhandenen Guthaben
Sortierung nach : Personen-ID</p>
<p>Adrnr      Name        Datum      Saldo Guth.  offene Fakturen</p>
<hr>
<p>629,768 Vogel-Etien 03.11.1998      100.00            0.00
640,878 Mikosch Bar 21.01.1999       29.00            0.00
.
.</p>
<p>912,638 Speck &amp; Ale 17.07.1995      230.00            0.00</p>
<hr>
<pre><code>                                29,093.20            0.00 TOTAL
</code></pre>
<p>COUNT</p>
<p>Lesebeispiel: Der Debitor Mikosch Bar hat Fr. 29.00 Guthaben im System. Das Guthaben ist per 21.1.99 im System entstanden bzw. zu diesem Datum wurde die letzte Änderung des Guthabens verzeichnet. Der Debitor hat keine offenen Fakturen. (D.h. bei einer Bereinigung müssen keine allfällig verrechneten Anteile von Guthaben berücksichtigt werden.) Insgesamt sind 352 Guthaben im Gesamtbetrag von 29'093.20 aufgelistet.</p>
</div></template>


